import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endPoint } from "../../service/api";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  tagTypes: ["getStatistics"],
  baseQuery: fetchBaseQuery({
    baseUrl: endPoint("/account"),
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getStatistics: builder.query({
      query: (params) => ({
        url: "/statistics",
        params,
      }),
      providesTags: ["getStatistics"],
    }),
    getRegisteredWalletsByCountry: builder.query({
      query: (params) => ({
        url: "/registered-wallets-by-country",
        params,
      }),
    }),
    getInOutChart: builder.query({
      query: (params) => ({
        url: "/in-out",
        params,
      }),
      providesTags: ["getStatistics"],
    }),
    updateTarget: builder.mutation({
      query: (params) => ({
        url: "/update-target",
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["getStatistics"],
    }),
  }),
});

export const {
  useGetRegisteredWalletsByCountryQuery,
  useGetStatisticsQuery,
  useGetInOutChartQuery,
  useUpdateTargetMutation,
} = dashboardApi;
